import { Link, Typography } from "@mui/material"
import { navigate } from "lib/routes/navigate"

export function TailoredLabel({ children, navigateTo, append = null }) {
    if (children === "-") return null
    if (navigateTo) {
        return (
            <Link onClick={go} data-cy="zero-u-schedule-link">
                <Typography variant="body2">
                    {children} {append}
                </Typography>
            </Link>
        )
    }
    return (
        <Typography variant="body2">
            {children} {append}
        </Typography>
    )

    function go() {
        navigate(`/app/schedules/${navigateTo}`)
    }
}
